module.exports = __webpack_public_path__ + "static/media/In_progress.a5c3e544.svg";